import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Order } from '@app/core/business/order/order';
import { OrderStatus } from '@app/core/business/order/order-status';
import { environment } from '@env/environment';
import { BehaviorSubject, EMPTY, Observable, of, Subject } from 'rxjs';
import { catchError, concatMap, delay, finalize, map, tap } from 'rxjs/operators';
import { OrderErrorLine } from '@app/core/business/order/order-error-line';
import { Product } from '../product/product';
interface QueueItem {
  companyCode: string;
  customerCode: string;
  orderCode: string;
  productCode: string;
  quantity: number;
  isDateCourte: boolean;
  observer: any;
}


@Injectable({
  providedIn: 'root',
})
export class OrderService {
  [x: string]: any;
  private baseUrl: string = environment.baseApiUrl;
  public isPrecommande: boolean = false;
  public orderInvalid$ = new BehaviorSubject<boolean>(false);

  private ordersMock: Order[] = [
    {
      code: 'order_1',
      customCode: 'my_order_1',
      date: new Date().toISOString(),
      deliveryDate: new Date().toISOString(),
      validityStartDate: new Date().toISOString(),
      validityEndDate: new Date(
        new Date().setSeconds(
          new Date().getSeconds() + Math.random() * 500 + 200
        )
      ).toISOString(),
      price: {
        total: '20',
        totalAfterTaxes: '40',
        unit: '€',
      },
      deliveryAddress: {
        code: 'address_1',
        type: 'address',
        name: 'Adresse principale',
        address1: '15 rue Paul Janet',
        address2: 'kjh',
        address3: 'kjh',
        city: 'Strasbourg',
        zipCode: '67000',
        country: 'France',
      },
      status: OrderStatus.CREATION_IN_PROGRESS,
      lines: [],
      outOfStockLines: [],
      count: 45,
      // errors: [],
    },
    {
      code: 'order_2',
      customCode: 'my_order_2',
      date: new Date().toISOString(),
      deliveryDate: new Date().toISOString(),
      validityStartDate: new Date().toISOString(),
      validityEndDate: new Date(
        new Date().setSeconds(new Date().getSeconds() + Math.random() * 10 + 5)
      ).toISOString(),
      price: {
        total: '20',
        totalAfterTaxes: '40',
        unit: '€',
      },
      deliveryAddress: {
        code: 'address_1',
        type: 'address',
        name: 'Adresse principale',
        address1: '15 rue Paul Janet',
        city: 'Strasbourg',
        zipCode: '67000',
        country: 'France',
      },
      status: OrderStatus.INACTIVE,
      lines: [],
      outOfStockLines: [],
      count: 24,
      // errors: [],
    },
    {
      code: 'order_3',
      customCode: 'my_order_3',
      date: new Date().toISOString(),
      deliveryDate: new Date().toISOString(),
      validityStartDate: new Date().toISOString(),
      validityEndDate: new Date(
        new Date().setSeconds(new Date().getSeconds() + Math.random() * 10 + 20)
      ).toISOString(),
      shippingUrl: 'https://picturepan2.github.io/spectre/getting-started.html',
      price: {
        total: '40,00',
        totalAfterTaxes: '48,00',
        unit: '€',
        taxes: ['3,00', '7,00'],
      },
      weight: {
        pallets: '4430',
        gross: '60430',
        net: '56',
        unit: 'kg',
      },
      deliveryAddress: {
        code: 'address_1',
        type: 'address',
        name: 'Adresse principale',
        address1: '15 rue Paul Janet',
        city: 'Strasbourg',
        zipCode: '67000',
        country: 'France',
      },
      status: OrderStatus.CREATED,
      lines: [
        {
          productCode: '2',
          ean: '9830238089283',
          brand: 'Test Brand',
          brandUrl: 'https://www.google.fr',
          label: 'Orange',
          quantity: 506,
          deliveredQuantity: 300,
          palletCode: 'code',
          scheduledQuantity: 205,
          tags: [
            {
              label: 'bio',
              url: 'https://picturepan2.github.io/spectre/img/spectre-logo.svg',
              affichageProduit: true,
              affichageFiltre: false,
            },
            {
              label: 'bio',
              url: 'https://picturepan2.github.io/spectre/img/spectre-logo.svg',
              affichageProduit: true,
              affichageFiltre: false,
            },
          ],
          outer: 4,
          unpackedQuantity: 2,
          weight: {
            pallets: '1500',
            gross: '140',
            net: '110',
            unit: 'g',
          },
          availability: 1,
          price: {
            discounts: ['0,50'],
            gross: '2,10',
            net: '2,50',
            grossByWeight: '1,10',
            netByWeight: '1,30',
            total: '14,00',
            totalAfterTaxes: '16,00',
            freeDeliveryMinimum: '30',
            fees: '2,00',
            taxes: ['2,00'],
            unit: '€',
            weightUnit: 'KG',
          },
          pictures: [],
        },
        {
          productCode: '1',
          ean: '5830238089283',
          brand: '1Test Brand',
          brandUrl: 'https://www.google.fr',
          label: 'Tangerine',
          quantity: 1200,
          deliveredQuantity: 1200,
          palletCode: 'code',
          scheduledQuantity: 0,
          tags: [
            {
              label: 'bio',
              url: 'https://picturepan2.github.io/spectre/img/spectre-logo.svg',
              affichageProduit: true,
              affichageFiltre: false,
            },
          ],
          outer: 5,
          unpackedQuantity: 1,
          availability: 1,
          weight: {
            pallets: '250',
            gross: '180',
            net: '90',
            unit: 'g',
          },
          price: {
            discounts: ['0,50'],
            gross: '2,00',
            net: '2,40',
            grossByWeight: '1,00',
            netByWeight: '1,20',
            total: '12,00',
            totalAfterTaxes: '14,00',
            freeDeliveryMinimum: '20',
            fees: '2,00',
            taxes: ['2,00'],
            unit: '€',
            weightUnit: 'KG',
          },
          pictures: [],
        },
      ],
      outOfStockLines: [
        {
          productCode: '2',
          ean: '9830238089283',
          brand: 'Test Brand',
          brandUrl: 'https://www.google.fr',
          label: 'Orange',
          quantity: 506,
          deliveredQuantity: 300,
          availability: 1,
          scheduledQuantity: 205,
          palletCode: 'code',
          tags: [
            {
              label: 'bio',
              url: 'https://picturepan2.github.io/spectre/img/spectre-logo.svg',
              affichageProduit: true,
              affichageFiltre: false,
            },
            {
              label: 'bio',
              url: 'https://picturepan2.github.io/spectre/img/spectre-logo.svg',
              affichageProduit: true,
              affichageFiltre: false,
            },
          ],
          outer: 4,
          unpackedQuantity: 0,
          weight: {
            pallets: '1500',
            gross: '140',
            net: '110',
            unit: 'g',
          },
          price: {
            discounts: ['0,50'],
            gross: '2,10',
            net: '2,50',
            grossByWeight: '1,10',
            netByWeight: '1,30',
            total: '14,00',
            totalAfterTaxes: '16,00',
            freeDeliveryMinimum: '30',
            fees: '2,00',
            taxes: ['2,00'],
            unit: '€',
            weightUnit: 'KG',
          },
          pictures: [],
        },
        {
          productCode: '1',
          ean: '5830238089283',
          brand: '1Test Brand',
          brandUrl: 'https://www.google.fr',
          label: 'Tangerine',
          quantity: 1200,
          deliveredQuantity: 1200,
          scheduledQuantity: 0,
          availability: 1,
          palletCode: 'code',
          tags: [
            {
              label: 'bio',
              url: 'https://picturepan2.github.io/spectre/img/spectre-logo.svg',
              affichageProduit: true,
              affichageFiltre: false,
            },
          ],
          outer: 5,
          unpackedQuantity: null,
          weight: {
            pallets: '250',
            gross: '180',
            net: '90',
            unit: 'g',
          },
          price: {
            discounts: ['0,50'],
            gross: '2,00',
            net: '2,40',
            grossByWeight: '1,00',
            netByWeight: '1,20',
            total: '12,00',
            totalAfterTaxes: '14,00',
            freeDeliveryMinimum: '20',
            fees: '2,00',
            taxes: ['2,00'],
            unit: '€',
            weightUnit: 'KG',
          },
          pictures: [],
        },
      ],
      count: 5,
      // errors: [
      //   {
      //     productCode: 'PX2345',
      //     reason: 'Vente hors saison impossible.',
      //   },
      //   {
      //     productCode: 'PA2255',
      //     reason: 'La production de ce produit à été suspendue.',
      //   },
      //   {
      //     productCode: 'AX3490',
      //     reason: 'Votre client à refusé ce produit',
      //   },
      // ],
    },
  ];

  // 🔹 Une seule file d’attente globale
  private globalQueue$ = new Subject<QueueItem>();



  constructor(private http: HttpClient) {
    // 🔸 Les requêtes sont traitées séquentiellement, dans l’ordre d’arrivée grace à un concatMap.
    this.globalQueue$
      .pipe(
        concatMap(item => {
          const body = {
            productCode: item.productCode,
            quantity: item.quantity,
            isDateCourte: item.isDateCourte
          };

          return this.http
            .post<Order>(
              `${this.baseUrl}/companies/${item.companyCode}/customers/${item.customerCode}/orders/${item.orderCode}`,
              body,
              { headers: { 'X-Bypass-Global-Error': item.isDateCourte.toString() } }
            )
            .pipe(
              tap(order => {
                // émet le résultat
                item.observer.next(order);
              }),
              // ⚠️ en cas d’erreur : on notifie l’observer mais on continue la queue
              catchError(err => {
                item.observer.error(err);
                return EMPTY;
              }),
              finalize(() => {
                // signale la fin (succès ou erreur)
                item.observer.complete();
              })
            );
        })
      )
      .subscribe();
  }
  /**
    * 🔹 Ajoute une requête dans la file d’attente globale
    */
  public postProductQuantity(
    companyCode: string,
    customerCode: string,
    orderCode: string,
    productCode: string,
    quantity: number,
    isDateCourte: boolean
  ): Observable<Order> {
    return new Observable<Order>(observer => {
      this.globalQueue$.next({
        companyCode,
        customerCode,
        orderCode,
        productCode,
        quantity,
        isDateCourte,
        observer
      });
    });
  }




  /**
   * Get a customer's orders
   * @param companyCode Code of the company
   * @param customerCode Code of the customer
   */
  public getOrders(
    companyCode: string,
    customerCode: string,
    current = false,
    forceLoading = false
  ): Observable<Order[]> {
    if (environment.useMock) {
      return of(this.ordersMock).pipe(delay(500));
    }

    const queryString = {
      current: current.toString(),
    };

    if (forceLoading) {
      queryString['forceLoading'] = 'true';
    }

    return this.http.get<Order[]>(
      `${this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/orders`,
      { params: queryString }
    );
  }

  /**
   * Get a single order
   * @param companyCode Code of the company
   * @param customerCode Code of the customer
   * @param orderCode Code of the order
   */
  public getOrder(companyCode: string, customerCode: string, orderCode: string, headerOnly = false): Observable<Order> {
    if (environment.useMock) {
      return of(this.ordersMock).pipe(
        map(orders => orders.find(o => o.code === orderCode)),
        delay(50)
      );
    }

    const queryString = { headerOnly: headerOnly.toString() };

    var order = this.http.get<Order>(`${this.baseUrl}/companies/${companyCode}/customers/${customerCode}/orders/${orderCode}`, { params: queryString });

    order.subscribe(async (order) => {
      // await this.checkAllProductsPreco(order, companyCode, customerCode);
    });

    return order;
  }

  /**
   * Merge order
   * @param companyCode Company code
   * @param customerCode Customer code
   * @param orderCode Order code
   * @param mergeWithOrder Order code to merge with
   */
  public postMerge(
    companyCode: string,
    customerCode: string,
    orderCode: string,
    mergeWithOrder?: string
  ): Observable<{ errorCount: number; errorLines: OrderErrorLine[] }> {
    const queryString = {
      mergeWithOrder: mergeWithOrder,
    };
    return this.http.post<{ errorCount: number; errorLines: OrderErrorLine[] }>(
      `${this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/orders/${orderCode}/merge`,
      {},
      { params: queryString }
    );
  }

  /**
   * Create order
   * CLA le 10/10/2019 - A/B - ajout du type de commande
   * @param companyCode Company code
   * @param customerCode Customer code
   * @param orderCode Order code
   * @param customCode Custom code
   * @param addressCode Address code
   * @param deliveryDate Delivery date
   * @param headerComment Customer order comment
   * @param orderType product type of the order
   */
  public postNewOrder(
    companyCode: string,
    customerCode: string,
    customCode?: string,
    addressCode?: string,
    deliveryDate?: string,
    headerComment?: string,
    orderType?: string
  ): Observable<Order> {
    const body = {
      customCode: customCode,
      addressCode: addressCode,
      deliveryDate: deliveryDate,
      comment: headerComment,
      orderType: orderType
    };
    return this.http.post<Order>(
      `${this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/orders`,
      body,
      { params: { forceLoading: 'true' } }
    );
  }

  /**
   * Order validation
   * @param companyCode Company code
   * @param customerCode Customer code
   * @param orderCode Order code
   * @param addressCode Address code
   * @param deliveryDate Delivery date
   * @param customCode Custom code
   * @param headerComment Customer order comment
   */
  public postValidate(
    companyCode: string,
    customerCode: string,
    orderCode: string,
    addressCode?: string,
    deliveryDate?: string,
    customCode?: string,
    headerComment?: string
  ): Observable<void> {
    let body = {};
    if (addressCode) {
      body['addressCode'] = addressCode;
    }
    if (deliveryDate) {
      body['deliveryDate'] = deliveryDate;
    }
    if (customCode) {
      body['customCode'] = customCode;
    }
    if (headerComment) {
      body['comment'] = headerComment;
    }

    /**
        const body = {
          customCode: customCode,
          addressCode: addressCode,
          deliveryDate: deliveryDate,
          comment: headerComment
        }; */
    return this.http.post<void>(
      `${this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/orders/${orderCode}/validate`,
      body,
      { params: { forceLoading: 'true' } }
    );
  }

  /**
   * Cancel order
   * @param companyCode Company code
   * @param customerCode Customer code
   * @param orderCode Order code
   */
  public deleteCancel(
    companyCode: string,
    customerCode: string,
    orderCode: string
  ): Observable<Object> {
    return this.http.delete(
      `${this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/orders/${orderCode}/cancel`,
      { params: { forceLoading: 'true' } }
    );
  }

  /**
   * Order reactivation
   * @param companyCode Company code
   * @param customerCode Customer code
   * @param orderCode Order code
   */
  public postReactivate(
    companyCode: string,
    customerCode: string,
    orderCode: string
  ): Observable<OrderErrorLine[]> {
    return this.http.post<OrderErrorLine[]>(
      `${this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/orders/${orderCode}/reactivate`,
      {}
    );
  }


  /**
   * Generate PDF for Order
   * @param companyCode Company code
   * @param customerCode Customer code
   * @param orderCode Order code
   */
  public downloadPdf(
    companyCode: string,
    customerCode: string,
    orderCode: string
  ): Observable<any> {
    return this.http.get(
      `${this.baseUrl
      }/companies/${companyCode}/customers/${customerCode}/orders/${orderCode}/pdf`,
      { responseType: 'arraybuffer' }
    );
  }

  /**
   * Get product (standard or date courte)
   * @param productCode 
   * @param companyCode 
   * @param customerCode 
   * @param isDateCourte Si le produit est une date courte, il faut changer l'endpoint
   */
  public getProduct(
    productCode: string,
    companyCode: string,
    customerCode: string,
    isDateCourte: boolean
  ): Observable<Product> {
    const endpoint = isDateCourte
      ? `datecourte/${productCode}`
      : productCode;

    return this.http.get<Product>(
      `${this.baseUrl}/companies/${companyCode}/products/${endpoint}`,
      { params: { customerCode } }
    );
  }


  // JDU: Je commente ce code qui est un peu bizarre : on vérifie si un produit est en préco en allant chercher le détail de chaque produit de la commande, 
  // ce qui peut être très long si la commande a beaucoup de lignes.
  // public async checkAllProductsPreco(order: Order, companyCode: string, customerCode: string): Promise<void> {
  //   if (!order || !order.lines) {
  //     this.isPrecommande = false;
  //     return;
  //   }

  //   for (const line of order.lines) {
  //     let productDetails = new Product();

  //       productDetails = await this.getProduct(line.productCode, companyCode, customerCode, line.isDateCourte).toPromise();

  //     if (productDetails.isPrecommande && !line.isDateCourte) {
  //       this.isPrecommande = true;
  //       return;
  //     }
  //   }
  //   this.isPrecommande = false;
  // }
}
